import script from "./GatewayLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./GatewayLocation.vue?vue&type=script&setup=true&lang=js"

import "./GatewayLocation.vue?vue&type=style&index=0&id=5fbf599b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fbf599b"]])

export default __exports__